



import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import Tree from 'tui-tree';
@Component({})
export default class Tuitree extends Vue {
  @Prop({required: true})
  private data!: [];
  private tree: any;
  @Prop()
  private isUpOrDown!: boolean;
  private curNo: string = '';
  private curNodeId: string = '';
  private options = {
    data: [],
    nodeDefaultState: 'closed',

    template: {
      internalNode: `<div class="tui-tree-content-wrapper ">
                        <button type="button" class="tui-tree-toggle-btn tui-js-tree-toggle-btn ">
                          <span class="tui-ico-tree"></span>
                        </button>
                        <span class="tui-tree-text tui-js-tree-text tui-tree-get-click">
                          {{text}}{{displayIcon}}
                        </span>
                      </div><ul class="tui-tree-subtree tui-js-tree-subtree">{{children}}</ul>`,
      leafNode: `<div class="tui-tree-content-wrapper" style="padding-left: {{indent}}px">
                      <span class="tui-tree-text tui-js-tree-text">
                          {{text}}{{displayIcon}}
                      </span>
                  </div>`
    }
  };
  @Watch('data')
  onDataChanged() {
    if (this.data.length === 0) return;
    if (!this.tree) {
      this.tree = new Tree('#treeRoot', this.options);
    }
    this.tree.resetAllData(this.data);
    for (var key in this.tree.model.treeHash) {
      if (key !== 'tui-tree-node-0' && this.tree.model.treeHash[key]._data) {
        if (this.tree.model.treeHash[key]._data.groupNo && this.tree.model.treeHash[key]._data.groupNo === this.curNo) {
          this.curNodeId = key;
        }
        if (this.tree.model.treeHash[key]._data.templateNo && this.tree.model.treeHash[key]._data.templateNo === this.curNo) {
          this.curNodeId = key;
          this.tree.open(this.curNodeId, true);
        }
      }
    }
    let nodeList = Object.keys(this.tree.model.treeHash);
    if (this.isUpOrDown) {
      this.$nextTick(() => {
        this.tree.select(this.curNodeId); //当前选中第几个
      });
    } else {
      this.$nextTick(() => {
        this.tree.select(nodeList[1]); //默认选中第一个
        this.tree.close(nodeList[1])
      });
    }
  }
  public addTree(obj: any, targetId?: any): void {
    const selectedNodeId = this.tree.getSelectedNodeId();
    this.tree.open(selectedNodeId);

    let template = this.tree.add(obj, targetId);
    if (targetId) {
      this.tree.open(template, true);
    }
    this.tree.select(template);
  }
  private mounted() {
    this.tree = new Tree('#treeRoot', this.options);
    // this.tree.enableFeature('Draggable', {
    //   helperClassName: 'tui-tree-drop',
    //   lineClassName: 'tui-tree-line',
    //   isSortable: true
    // });
    this.tree.enableFeature('Selectable', {
      selectedClassName: 'tui-tree-selected'
    });
    this.tree.on('select', (eventData: any) => {
      var nodeData = this.tree.getNodeData(eventData.nodeId);

      this.curNo = nodeData.groupNo || nodeData.templateNo;
      const depth = this.tree.getDepth(eventData.nodeId);
      const parentId = this.tree.getParentId(eventData.nodeId);
      const parentData = this.tree.getNodeData(parentId);
      this.$emit('changeSelect', {theObj: nodeData, theIndex: depth, theParentData: parentData});
      this.tree.open(eventData.nodeId);
    });
  }
}
